import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
export default new Router({
	routes: [
		// {
		// 	path: '/',
		// 	redirect: '/login'
		// },

		// {
		// 	path: '/',
		// 	component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
		// 	meta: {
		// 		title: 'Home'
		// 	},
		// 	children: [
		// 		// 系统首页
		// 		{
		// 			path: '/dashboard',
		// 			component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Dashboard.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_0'
		// 			}
		// 		},
		// 		{
		// 			name: 'T13011',
		// 			path: '/POPLUS/T13011',
		// 			component: () => import( /* webpackChunkName: "POPLUS" */ '../pages/POPLUS/T13011.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_6'
		// 			}
		// 		},
		// 		{
		// 			name: 'T13021',
		// 			path: '/POPLUS/T13021',
		// 			component: () => import( /* webpackChunkName: "POPLUS" */ '../pages/POPLUS/T13021.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_7'
		// 			}
		// 		},
		// 		{
		// 			name: 'Analysis_goldstat_List',
		// 			path: '/FSBI/Analysis_goldstat/Analysis_goldstat_List',
		// 			component: () => import( /* webpackChunkName: "POPLUS" */ '../pages/FSBI/Analysis_goldstat/Analysis_goldstat_List.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_10'
		// 			}
		// 		},
				
		// 		{
		// 			name: 'Analysis_inventory_eom_List',
		// 			path: '/FSBI/Analysis_inventory_eom/Analysis_inventory_eom_List',
		// 			component: () => import( /* webpackChunkName: "POPLUS" */ '../pages/FSBI/Analysis_inventory_eom/Analysis_inventory_eom_List.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_12'
		// 			}
		// 		},
				
		// 		{
		// 			name: 'Analysis_inventory_current',
		// 			path: '/FSBI/Analysis_inventory_current/Analysis_inventory_current',
		// 			component: () => import( /* webpackChunkName: "POPLUS" */ '../pages/FSBI/Analysis_inventory_current/Analysis_inventory_current.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_11'
		// 			}	
		// 		},

				
				
		// 		{
		// 			name: 'nav_list',
		// 			path: '/FSBI/ad_min/nav_list',
		// 			component: () => import( /* webpackChunkName: "FSBI" */ '../pages/FSBI/ad_min/nav_list.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_1'
		// 			}
		// 		},
				
		// 		{
		// 			name: 'role_list',
		// 			path: '/FSBI/ad_min/role_list',
		// 			component: () => import( /* webpackChunkName: "FSBI" */ '../pages/FSBI/ad_min/role_list.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_8'
		// 			}
		// 		},
		// 		{
		// 			name: 'managers',
		// 			path: '/FSBI/ad_min/managers',
		// 			component: () => import( /* webpackChunkName: "FSBI" */ '../pages/FSBI/ad_min/managers.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_9'
		// 			}
		// 		},
		// 		{
		// 			name: 'manager_Edit',
		// 			path: '/FSBI/ad_min/manager_Edit',
		// 			component: () => import( /* webpackChunkName: "FSBI" */ '../pages/FSBI/ad_min/manager_Edit.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_9'
		// 			}
		// 		},

		// 	]
		// },
		// {
		// 	path: '/login',
		// 	component: () => import( /* webpackChunkName: "login" */ '../pages/Login.vue'),
		// 	meta: {
		// 		title: 'login.login_1'
		// 	}
		// },
		// {
		// 	path: '/forgetPwd',
		// 	component: () => import( /* webpackChunkName: "forgetPwd" */ '../pages/forgetPwd.vue'),
		// 	meta: {
		// 		title: 'forgetPwd'
		// 	}
		// },
		// {
		// 	path: '*',
		// 	redirect: '/404'
		// }
		
		{
		    path: '/login',
		    component: () => import(/* webpackChunkName: "login" */ '../pages/Login.vue'),
		    meta: { title: 'login.login_1' }
		},
		// {
		//     path: '/Dashboard',
		//     component: () => import(/* webpackChunkName: "Dashboard" */ '../pages/Dashboard.vue'),
		//     meta: { title: '首页' }
		// },
		{
		    path: '/404',
			component: () => import(/* webpackChunkName: "404" */ '../pages/404.vue'),
			meta: { title: '404' }
		}
	]
});
